import {
    PlayerInfoFragment,
    PlayerInfoWithProjectionsFragment,
    PlayerProjectionFragment,
    TeamInfoFragment,
} from '@/api/events/query.generated';
import { EventInfo } from '@/api/events/types/types';
import { PlayerPickSelectionProps } from '@/feature/lobby/components/PickProjectionButtonsSection';

interface PropsForPickOut {
    player: (PlayerInfoWithProjectionsFragment & { team?: TeamInfoFragment }) | PlayerInfoFragment;
    event?: EventInfo;
    playerProjections?: PlayerProjectionFragment[];
    team?: TeamInfoFragment;
    analyticsTag?: string;
}

export function createPropsForPickOut({
    event,
    playerProjections,
    player,
    analyticsTag,
}: PropsForPickOut): PlayerPickSelectionProps | undefined {
    if (event && playerProjections) {
        return {
            player: {
                ...player,
                league: event.league,
                sport: event.sport,
                projections: playerProjections,
            },
            event,
            ...(analyticsTag && { analyticsTag }),
        };
    }
    return undefined;
}
